import { Outlet, BrowserRouter, Routes, Route } from "react-router-dom";
import CodexOutlet from "nodes/codex/CodexOutlet";
import BlogOutlet from "nodes/blog/BlogOutlet";
import BlogPostIntroduceCardMemoir from "nodes/blog/BlogPostIntroduceCardMemoir";
import BlogPostCommunitiesTemplateDeck from "nodes/blog/BlogPostCommunitiesTemplateDeck";
import BlogPostDrawingChallengeCard from "nodes/blog/BlogPostDrawingChallengeCard";
import BlogPostOrderPhysicalPrints from "nodes/blog/BlogPostOrderPhysicalPrints";

/**
 * Typesafe STATIC routing
 * IMPORTANT: Changing any value must be reflected in public/sitemap.xml
 *
 * Owner @cmizony-mizony
 */
export enum STATIC_ROUTES {
  ROOT = "/",
  BLOG_INTRODUCE_CARD_MEMOIR = "/blog/2025-03-introduce-card-memoir",
  BLOG_COMMUNITIES_TEMPLATE_DECK = "/blog/2025-04-communities-template-deck",
  BLOG_DRAWING_CHALLENGE_CARD = "/blog/2025-04-drawing-challenge-card",
  BLOG_ORDER_PHYSICAL_PRINTS = "/blog/2025-05-order-physical-prints",
}

const CodexRoutes = () => (
  <BrowserRouter>
    <Routes>
      <Route path="/" element={<Outlet />}>
        <Route index element={<CodexOutlet />} />
        <Route path="blog/" element={<BlogOutlet />}>
          <Route
            path="2025-03-introduce-card-memoir"
            element={<BlogPostIntroduceCardMemoir />}
          />
          <Route
            path="2025-04-communities-template-deck"
            element={<BlogPostCommunitiesTemplateDeck />}
          />
          <Route
            path="2025-04-drawing-challenge-card"
            element={<BlogPostDrawingChallengeCard />}
          />
          <Route
            path="2025-05-order-physical-prints"
            element={<BlogPostOrderPhysicalPrints />}
          />
        </Route>
        <Route path="*" element={<CodexOutlet />} />
      </Route>
    </Routes>
  </BrowserRouter>
);

export default CodexRoutes;
